import { render, staticRenderFns } from "./PracticeInvitation.vue?vue&type=template&id=23a6129d&"
import script from "./PracticeInvitation.vue?vue&type=script&lang=js&"
export * from "./PracticeInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports